module.exports = __webpack_public_path__ + "0d591fccbb8986ce736de4873dc45c2b.fbx";